import { render, staticRenderFns } from "./functionBtn.vue?vue&type=template&id=95070b40&scoped=true&"
import script from "./functionBtn.vue?vue&type=script&lang=js&"
export * from "./functionBtn.vue?vue&type=script&lang=js&"
import style0 from "./functionBtn.vue?vue&type=style&index=0&id=95070b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95070b40",
  null
  
)

export default component.exports